import { Component, OnInit, Input, Inject, AfterContentChecked, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { PageService } from '../../page/services/page.service';
import { DocumentosComponent } from '../documentos/documentos.component';
import { ActivatedRoute } from '@angular/router';

import jwtDecode from 'jwt-decode';


import { sanitizeIdentifier } from '@angular/compiler';

import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ClienteComponent } from '../../components/cliente/cliente.component';
import { Router } from '@angular/router';


import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatStepperModule} from '@angular/material/stepper';
import { DatePipe } from '@angular/common';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ModalInjectorService} from '../../page/services/modal-injector.service';


@Component({
  selector: 'app-update-solicitud-modal',
  templateUrl: './update-solicitud-modal.component.html',
  styleUrls: ['./update-solicitud-modal.component.css']
})
export class UpdateSolicitudModalComponent implements OnInit, AfterContentChecked {
  
    @ViewChild('checkGDPR') checkGDPR: ElementRef;
    token: string;
    show: boolean;
    validate: boolean;
    tokenInfo: any;
    isTDGT = false;
    showUploaded = false;
    idSolicitud: string;
    completada = false;
    completada2 = false;
    completada3 = false;
    btnFinalizar=true;
    siglas = [];
    esReinicia=false;
    faltaMarcaModelo=false;
    esMoves=false;
    titulo:any;
    requeridosOK = true;
  
  //
  
  marcaModelo = new FormControl('');
  autonomiaKm=new FormControl('');
  potenciaKwh=new FormControl('');
  
  options: string[] = [];
  
  filteredOptions: Observable<string[]>;
  formData: FormData;
  
  datosCliente: FormGroup;
  datosVehiculos: FormGroup;
  datosAyuda: FormGroup;
  documentos: FormGroup;
  isEditable = false;
  isEditable2 = false;
  isEditable3 = false;
  exencion: boolean;
  solicitud: string;
  observacion: any;
  provincias: any[];
  provinciasVendedor: any[];
  ocultar = true;
  clienteComprador: any;
  archivos: any[] = [];
  clasif: any;
  spinnerFirma: any;
  spinnerEITV = false;
  recuperadoEITV = true;
  mostrarCif = false;
  mostrarIAE = false;
  mostrarMinimis = false;
  achatarra = false;
  hoy = new Date();
  option: any;
  
  @Input() datoTramite: any;
  
  NIFApoderadoVendedor: string;
  apellido1: string;
  apellido1Apoderado: string;
  apellido1ApoderadoVendedor: string;
  apellido1Vendedor: string;
  apellido2: string;
  apellido2Apoderado: string;
  apellido2ApoderadoVendedor: string;
  apellido2Vendedor: string;
  ayudaAdicional: string;
  baseImponible: string;
  bastidor: string;
  bastidorPEX: string;
  cargas: string;
  cif: string;
  cilindrada: string;
  co2: string;
  codigoAutorizacion: string;
  colaborador: string;
  comunicacionAdicional: string;
  conceptoRepresentacionApoderado: string;
  conceptoRepresentacionApoderadoVendedor: string;
  concesion: string;
  cp: string;
  cpVendedor: string;
  cv: string;
  demo: false;
  vehiculoNuevo: false;
  direccion: string;
  direccionBloque: string;
  direccionCorrespondenciaCliente: string;
  direccionCorrespondenciaClienteBloque: string;
  direccionCorrespondenciaClienteCP: string;
  direccionCorrespondenciaClienteEscalera: string;
  direccionCorrespondenciaClienteNumero: string;
  direccionCorrespondenciaClientePiso: string;
  direccionCorrespondenciaClientePoblacion: string;
  direccionCorrespondenciaClienteProvincia: string;
  direccionCorrespondenciaClientePuerta: string;
  direccionEscalera: string;
  direccionVendedor: string;
  direccionnumero: string;
  direccionnumeroVendedor: string;
  direccionpiso: string;
  direccionpisoVendedor: string;
  direccionpuerta: string;
  direccionpuertaVendedor: string;
  direccionBloqueVendedor: string;
  direccionEscaleraVendedor: string;
  email: string;
  emailVendedor: string;
  enviarDocCorreo: string;
  enviarDocCorreoVendedor: string;
  epigrafeIAE: string;
  facturarA: string;
  fecha: string;
  fechaAchatarrado: string;
  fechaAsignacion: string;
  fechaMatriculacion: string;
  fechaMatriculacionPEX: string;
  fechaNacimiento: string;
  fechaNacimientoVendedor: string;
  fechaInicioProyecto: string;
  fechaFinalProyecto: string;
  firma1: string;
  garantia: string;
  generadoExpediente: string;
  iban: string;
  importeMinimis: string;
  importeTotalFactura: string;
  impuestoMatriculacion: string;
  km: string;
  marca: string;
  marcaAchatarrado: string;
  marcaModeloElectrico: string;
  matricula: string;
  matriculaAchatarrado: string;
  matriculaPEX: string;
  modelo: string;
  modeloAchatarrado: string;
  expedienteConsorcio: string;
  nIFApoderadoVendedor: string;
  nif: string;
  nifApoderado: string;
  nifVendedor: string;
  nombre: string;
  nombreApoderado: string;
  nombreApoderadoVendedor: string;
  nombreVendedor: string;
  nroVentas: string;
  numPedido: string;
  observaciones: string;
  poblacion: string;
  poblacionVendedor: string;
  potenciaElectrico: 12;
  potenciaFiscal: string;
  provincia: string;
  provinciaId: string;
  provinciaIdVendedor: string;
  provinciaVendedor: string;
  pueblo: string;
  puebloVendedor: string;
  renting: string;
  servicioalquesedestina: string;
  sexo: string;
  sexoVendedor: string;
  solicitadoivareducido: string;
  solicitardistintivo: string;
  telefono: string;
  telefonoVendedor: string;
  tipo: string;
  tipoAdquisicion: string;
  tipoAyuda: string;
  tipoImpositivo: string;
  tipoSolicitante: string;
  tipoTramite: string;
  tipoVehiculo: string;
  tipoVia: string;
  tipoViaVendedor: string;
  tipoexencion: string;
  tipotransferencia: string;
  usuarioAsignado: string;
  provinciasCorresp = [];
  provinciaCorresp: string;
  
  municipios = [];
  municipiosVendedor = [];
  municipiosCorresp = [];
  municipio: string;
  municipioCorresp: string;
  
  reduccionEmisiones: string;
  ahorroEnergetico: string;
  tipoInstalacion: string;
  numeroConectores: string;
  tipoConector: string;
  marcaModeloCargador: string;
  inversionTotal: string;
  
  tipoAyudaSigla: string;
  
    
  
    constructor(public dialogRef: MatDialogRef<UpdateSolicitudModalComponent>,private pageService: PageService, @Inject(MAT_DIALOG_DATA)public data: any, private checkData: ModalInjectorService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
      private fb: FormBuilder,
      private servicio: PageService,
      private router: Router,
      private date: DatePipe,) {
      this.token = this.route.snapshot.queryParamMap.get('token');
      
      this.formData = new FormData();
      
      //this.idSolicitud = this.route.snapshot.queryParamMap.get('ref');
      //console.log(this.idSolicitud);
    }
  
    ngOnInit(): void {
      this.show = true;
      this.inicio();
    }
  
    inicio(): void {
      console.log("this.data:");
      console.log(this.data);
      this.solicitud = this.data.id;
      this.idSolicitud=this.data.id;
      sessionStorage.setItem('tipoCliente', '1');
      this.titulo="AYUDA MOVES";
      if(this.esReinicia)
      {
        sessionStorage.setItem('tipo', 'AYUDA REINICIA');
        this.titulo="AYUDA REINICIA";
      }
      else
        sessionStorage.setItem('tipo', 'AYUDA MOVES');
      
      //sessionStorage.setItem('token', this.token);
      
      this.clasificaciones();
      this.getProvincia();//Dentro se llama a getSolicitud y dentro de getSolicitud se llama a getMunicipioByName
      this.getSiglas();
      if (this.show===false || this.validate===false) {
        //this.router.navigate(['page/home']);
      }
      this.crearFormulario();
      
      if (this.solicitud !== 'null') {
        //console.log('aca');
        //this.getSolicitud();
        //this.getMunicipioByName();
      }
    }
  
    get matriculaNoValido(): any {
      return (
        this.datosVehiculos.get('matricula').invalid &&
        this.datosVehiculos.get('matricula').touched
      );
    }
  
    crearFormulario(): any {
      this.datosCliente = this.fb.group({
        nif: ['', [Validators.required, this.comprobarDato.bind(this)]],
        nifApoderado: '',
        apellido1: ['', [Validators.required]],
        apellido1Apoderado: '',
        apellido2: '',
        apellido2Apoderado: '',
        nombre: '',
        nombreApoderado: '',
        conceptoRepresentacionApoderado: '',
        sexo: ['', [Validators.required]],
        fechaNacimiento: '',
        email: [
          '',
          [
            Validators.minLength(5),
            Validators.pattern(
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ),
            Validators.required,
          ],
        ],
        telefono: ['', [Validators.required, this.comprobarNumero.bind(this)]],
        nifVendedor: '',
        nifApoderadoVendedor: '',
        apellido1Vendedor: '',
        apellido1ApoderadoVendedor: '',
        apellido2Vendedor: '',
        apellido2ApoderadoVendedor: '',
        nombreVendedor: '',
        nombreApoderadoVendedor: '',
        conceptoRepresentacionApoderadoVendedor: '',
        sexoVendedor: '',
        fechaNacimientoVendedor: '',
        emailVendedor: [
          '',
          [
            Validators.minLength(5),
            Validators.pattern(
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
          ],
        ],
        telefonoVendedor: ['', [this.comprobarNumero.bind(this)]],
        enviarDocCorreo: '0',
        direcciones: '',
        provincia: '',
        poblacion: '',
        pueblo: '',
        cp: [
          '',
          [Validators.maxLength(5), Validators.minLength(5), Validators.required],
        ],
        tipoVia: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        direccionnumero: ['', [Validators.required]],
        direccionpiso: '',
        direccionpuerta: '',
        direccionBloque: '',
        direccionEscalera: '',
        direccionCorrespondenciaCliente: '',
        direccionCorrespondenciaClienteNumero: '',
        direccionCorrespondenciaClientePiso: '',
        direccionCorrespondenciaClientePuerta: '',
        direccionCorrespondenciaClienteBloque: '',
        direccionCorrespondenciaClienteEscalera: '',
        direccionCorrespondenciaClienteCP: '',
        direccionCorrespondenciaClientePoblacion: '',
        direccionCorrespondenciaClienteProvincia: '',

        provinciaVendedor: '',
        poblacionVendedor: '',
        puebloVendedor: '',
        cpVendedor: [
          '',
          [Validators.maxLength(5), Validators.minLength(5)],
        ],
        tipoViaVendedor: '',
        direccionVendedor: '',
        direccionnumeroVendedor: '',
        direccionpisoVendedor: '',
        direccionpuertaVendedor: '',
        direccionBloqueVendedor: '',
        direccionEscaleraVendedor: '',

      });
  
      
  
      this.datosVehiculos = this.fb.group({
        matricula: '',
        tipo: '',
        colaborador: '',
        usuarioweb: '',
        tipoVehiculo: '10',
        //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
        //exencion: '0',
        //tipoexencion: 'NS2',
        //renting: '0',
        //solicitardistintivo: '0',
        bastidor: '',
        marca: '',
        modelo: '',
        //tipoImpositivo: '0',
        baseImponible: '0.00',
        cv: '',
        co2: ['0', [Validators.minLength(1)]],
        //impuestoMatriculacion: '',
        //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
        fechaMatriculacion: [null],
        cilindrada: '',
        potenciaFiscal: '',
      });
  
      this.datosAyuda = this.fb.group({
        //apellido1: '',
        //apellido1Apoderado: '',
        //apellido2: '',
        //apellido2Apoderado: '',
        //nombre: '',
        //nombreApoderado: '',
        sexo: '',
        fechaNacimiento: '',
        tipoSolicitante: 'PARTICULAR ESPAÑOL',
        tipoAdquisicion: 'DIRECTA',
        tipoAyuda: 'VEHICULO',
        demo: '0',
        vehiculoNuevo: '0',
        cif: '',
        IAE: '',
        minimis: '',
        achatarra: '0',
        facturar: 'CONCESION',
        marcaModelo: '',
        autonomiaKm: '',
        potenciaKwh: '',
        IBAN: '',
        fechaAchatarrado: '',
        fechaInicioProyecto: '',
        fechaFinalProyecto: '',
        matriculaAchatarrado: ['', [Validators.required]],
        marcaAchatarrado: '',
        modeloAchatarrado: '',
        expedienteConsorcio: '',
        adicional: 'NO',
        reduccionEmisiones: '',
        ahorroEnergetico: '',
        tipoInstalacion: '',
        numeroConectores: '',
        tipoConector: '',
        marcaModeloCargador: '',
        inversionTotal: ''
      });
  
    }
  
    getVehiculo(): void {
      if (this.datosVehiculos.value.matricula.length > 5) {
        this.servicio
          .getOneVehiculo(this.datosVehiculos.value.matricula)
          .subscribe(
            (res) => {
              console.log(res);
              if (res.matricula === this.datosVehiculos.value.matricula) {
                if (res.vehiculo != null) {
                  this.setDatos(res.vehiculo);
                } else {
                  this.datosVehiculos.setValue({
                    tipo: '',
                    colaborador: '',
                    matricula: this.datosVehiculos.value.matricula
                      ?.toUpperCase()
                      .trim(),
                    usuarioweb: '',
                    bastidor: '',
                    tipoVehiculo: '10',
                    marca: '',
                    modelo: '',
                    //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
                    //exencion: '0',
                    //tipoexencion: 'NS2',
                    //cargas: '',
                    baseImponible: null,
                    //nroVentas: '',
                    fechaMatriculacion: null,
                    cilindrada: '',
                    potenciaFiscal: '',
                    cv: '',
                    co2: null,
                    //renting: 'NO',
                    //solicitardistintivo: '0',
                    //tipoImpositivo: '0',
                    //impuestoMatriculacion: '',
                    //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
                  });
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else if (this.datosVehiculos.value.matricula.length < 4) {
        this.datosVehiculos.setValue({
          tipo: '',
          colaborador: '',
          matricula: this.datosVehiculos.value.matricula?.toUpperCase().trim(),
          usuarioweb: '',
          bastidor: '',
          tipoVehiculo: '10',
          marca: '',
          modelo: '',
          //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
          //exencion: '0',
          //tipoexencion: '0',
          //cargas: '',
          baseImponible: null,
          //nroVentas: '',
          fechaMatriculacion: null,
          cilindrada: '',
          potenciaFiscal: '',
          cv: '',
          co2: null,
          //renting: 'NO',
          //solicitardistintivo: '0',
          //tipoImpositivo: '0',
          //impuestoMatriculacion: '',
          //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
        });
      }
    }
  
    setDatos(datos): void {
      console.log(datos.tipoVehiculo);
      if (datos.tipoVehiculo !== null) {
        this.datosVehiculos.controls.tipoVehiculo.setValue(
          datos.tipoVehiculo?.trim().slice(0, 2)
        );
      } else {
        this.datosVehiculos.controls.tipoVehiculo.setValue(
          datos.tipoVehiculo?.trim() === '' ? '10' : datos.tipoVehiculo?.trim()
        );
      }/*
      if (
        datos.servicioalquesedestina === null ||
        datos.servicioalquesedestina === 'null' ||
        datos.servicioalquesedestina === 'NULL' ||
        // tslint:disable-next-line:max-line-length
        datos.servicioalquesedestina === '' ||
        datos.servicioalquesedestina === 'undefined' ||
        datos.servicioalquesedestina === 'UNDEFINED'
      ) {
        this.datosVehiculos.controls.servicioalquesedestina.setValue(
          'B00 - PART-SIN ESPECIFICAR'
        );
      } else {
        this.datosVehiculos.controls.servicioalquesedestina.setValue(
          datos.servicioalquesedestina
        );
      }*/
      //const exencion = this.getRespuesta(datos.exencion);
      //this.datosVehiculos.controls.exencion.setValue(exencion);
      //this.datosVehiculos.controls.tipoexencion.setValue(datos.tipoexencion);
      //const renting = this.getRespuesta(datos.renting);
      //this.datosVehiculos.controls.renting.setValue(renting);
      //const solicitardistintivo = this.getRespuesta(datos.solicitardistintivo);
      //this.datosVehiculos.controls.solicitardistintivo.setValue(
      //  solicitardistintivo
      //);
      this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
      this.datosVehiculos.controls.baseImponible.setValue(datos.baseImponible);
      this.datosVehiculos.controls.cv.setValue(datos.hp);
      //this.datosVehiculos.controls.tipoImpositivo.setValue(datos.tipoImpositivo);
      this.datosVehiculos.controls.co2.setValue(datos.co2);
      this.datosVehiculos.controls.potenciaFiscal.setValue(datos.potencianetaitv);
      this.datosVehiculos.controls.cilindrada.setValue(datos.cilindrada);
      this.datosVehiculos.controls.fechaMatriculacion.setValue(datos.fechaMatriculacion);
      this.datosVehiculos.controls.marca.setValue(datos.marca);
      this.datosVehiculos.controls.modelo.setValue(datos.modelo);
      this.datosVehiculos.controls.tipoVehiculo.setValue(datos.clasificacion.slice(0, 2));
      //this.datosVehiculos.controls.impuestoMatriculacion.setValue(
      //  datos.impuestoMatriculacion
      //);
      //this.datosVehiculos.controls.importeTotalFactura.setValue(
      //  datos.importeTotalFactura
      //);
      //sessionStorage.setItem('tipo', datos.tipo);
    }
  
    getProvincia(): void {
      this.servicio.getProvincia().subscribe(
        async (res) => {
          console.log(res);
          this.provincias = await res;
          this.provinciasVendedor=this.provincias;
          this.getSolicitud();
        },
        (error) => {
          console.log(error);
        }
      );
    }
  
    getexencion(event): any {
      if (event === '1') {
        this.exencion = true;
      } else {
        if (event === '0') {
          this.exencion = false;
          this.datosVehiculos.controls.tipoexencion.setValue('');
        }
      }
      console.log(this.exencion);
    }
  
    ngAfterContentChecked(): void {
      this.cdRef.detectChanges();
  
    }
  
    getAchatarra(event): any {
      console.log("getAchatarra:");
      if (event === '1') {
        this.achatarra = true;
      } else {
        if (event === '0') {
          this.achatarra = false;
          //this.datosVehiculos.controls.achatarra.setValue('0');
        }
      }
      console.log(this.achatarra);
    }
  
    getMarcaModelo(): any {
      console.log("getMarcaModelo:");
      console.log(this.marcaModelo.value);
      //this.options = [];
      let resultado=this.servicio
      .getModeloIdae(this.marcaModelo.value)
      .subscribe((res) => {
        if (res !== null) {
          console.log(res);
          this.options=[];
          let arr2: string[] = new Array();
          res.forEach(item=>{this.options.push(item)}); 
        } else {
          console.log("No se encuentra el modelo")
        }
      });
    }
  
    onSelectionChange(event){
      console.log('onSelectionChange called', event.option.value.Modelo);
      this.marcaModelo.setValue(event.option.value.Modelo);
      console.log('Valor campo marcaModelo:', this.marcaModelo.value);
      //var potenciaNumber: number = +event.option.value.Potencia_Electrica;
      this.datosAyuda.controls['potenciaKwh'].setValue(event.option.value.Potencia_Electrica);
      //var autonomiaNumber: number = +event.option.value.Autonomia_Electrica;
      this.datosAyuda.controls['autonomiaKm'].setValue(event.option.value.Autonomia_Electrica);
    }
  
    mostrarCampos(): void {
      console.log("mostrarCampos:");
      console.log(this.datosAyuda.value.tipoSolicitante);
      switch (this.datosAyuda.value.tipoSolicitante) {
        case 'PROFESIONAL AUTONOMO':
          this.mostrarCif = true;
          this.mostrarIAE = true;
          this.mostrarMinimis =false;
  
          //this.datosAyuda.get('cif').setValidators([Validators.required]);
          //this.datosAyuda.get('cif').updateValueAndValidity();
  
          //this.datosAyuda.get('IAE').setValidators([Validators.required]);
          //this.datosAyuda.get('IAE').updateValueAndValidity();
          break;
        case 'SOCIEDAD ANONIMA':
        case 'SOCIEDAD LIMITADA':
        case 'COMUNIDAD DE BIENES':
        case 'COMUNIDAD DE PROPIETARIOS':
          this.mostrarCif = true;
          this.mostrarIAE = true;
          this.mostrarMinimis =true;
  
          //this.datosAyuda.get('cif').setValidators([Validators.required]);
          //this.datosAyuda.get('cif').updateValueAndValidity();
  
          //this.datosAyuda.get('IAE').setValidators([Validators.required]);
          //this.datosAyuda.get('IAE').updateValueAndValidity();
          break;
        default:
          this.mostrarCif = false;
          this.mostrarIAE = false;
          this.mostrarMinimis =false;
  
          this.datosAyuda.get('cif').clearValidators();
          this.datosAyuda.get('cif').updateValueAndValidity();
  
          this.datosAyuda.get('IAE').clearValidators();
          this.datosAyuda.get('IAE').updateValueAndValidity();
  
          this.datosAyuda.get('minimis').clearValidators();
          this.datosAyuda.get('minimis').updateValueAndValidity();
          break;
      }
    }
  
    getSolicitud(): void {
      this.pageService.getOneSolicitud(this.idSolicitud).subscribe((res) => {
        //AYUDA
        console.log("Recuperando datos id solicitud:"+this.idSolicitud);
        console.log(res);
        this.datosCliente.controls.nif.setValue(res.nif);
        this.datosCliente.controls.apellido1.setValue(res.apellido1);
        this.datosCliente.controls.apellido2.setValue(res.apellido2);
        this.datosCliente.controls.nombre.setValue(res.nombre);
        this.datosCliente.controls.sexo.setValue(res.sexo);
        this.datosCliente.controls.fechaNacimiento.setValue(res.fechaNacimiento);
        this.datosCliente.controls.telefono.setValue(res.telefono);
        this.datosCliente.controls.email.setValue(res.email);
        this.datosCliente.controls.conceptoRepresentacionApoderado.setValue(res.conceptoRepresentacionApoderado);
        this.datosCliente.controls.nifApoderado.setValue(res.nifApoderado);
        this.datosCliente.controls.apellido1Apoderado.setValue(res.apellido1Apoderado);
        this.datosCliente.controls.apellido2Apoderado.setValue(res.apellido2Apoderado);
        this.datosCliente.controls.nombreApoderado.setValue(res.nombreApoderado);

        this.datosCliente.controls.nifVendedor.setValue(res.nifVendedor);
        this.datosCliente.controls.apellido1Vendedor.setValue(res.apellido1Vendedor);
        this.datosCliente.controls.apellido2Vendedor.setValue(res.apellido2Vendedor);
        this.datosCliente.controls.nombreVendedor.setValue(res.nombreVendedor);
        this.datosCliente.controls.sexoVendedor.setValue(res.sexoVendedor);
        this.datosCliente.controls.fechaNacimientoVendedor.setValue(res.fechaNacimientoVendedor);
        this.datosCliente.controls.telefonoVendedor.setValue(res.telefonoVendedor);
        this.datosCliente.controls.emailVendedor.setValue(res.emailVendedor);
        this.datosCliente.controls.conceptoRepresentacionApoderadoVendedor.setValue(res.conceptoRepresentacionApoderadoVendedor);
        this.datosCliente.controls.nifApoderadoVendedor.setValue(res.NIFApoderadoVendedor);
        this.datosCliente.controls.apellido1ApoderadoVendedor.setValue(res.apellido1ApoderadoVendedor);
        this.datosCliente.controls.apellido2ApoderadoVendedor.setValue(res.apellido2ApoderadoVendedor);
        this.datosCliente.controls.nombreApoderadoVendedor.setValue(res.nombreApoderadoVendedor);


        this.datosCliente.controls.provincia.setValue(res.provincia);
        this.provincia=res.provincia;
        if(res.provincia!=null)
        {
          if(res.provincia.length>2)
          {
            this.getMunicipioByName(res.provincia);
          }
          else
          {
            console.log("PROVINCIA MAL GUARDADA");
            this.provincias.map((p) => {
              if (p.idprov.includes(res.provincia)) {
                this.datosCliente.controls.provincia.setValue(p.nomprov);
                this.provincia = p.nomprov;
                console.log('Provincia getMunicipio: ', this.provincia);
              }
            });
            this.getMunicipioByName(this.datosCliente.controls.provincia.value);
          }
        }
        this.datosCliente.controls.poblacion.setValue(res.poblacion);
        this.poblacion=res.poblacion;
        this.datosCliente.controls.pueblo.setValue(res.pueblo);
        this.datosCliente.controls.cp.setValue(res.cp);
        this.datosCliente.controls.tipoVia.setValue(res.tipoVia);
        this.datosCliente.controls.direccion.setValue(res.direccion);
        this.datosCliente.controls.direccionnumero.setValue(res.direccionnumero);
        this.datosCliente.controls.direccionpiso.setValue(res.direccionpiso);
        this.datosCliente.controls.direccionpuerta.setValue(res.direccionpuerta);
        this.datosCliente.controls.direccionBloque.setValue(res.direccionBloque);
        this.datosCliente.controls.direccionEscalera.setValue(res.direccionEscalera);

        this.datosCliente.controls.provinciaVendedor.setValue(res.provinciaVendedor);
        this.provinciaVendedor=res.provinciaVendedor;
        if(res.provinciaVendedor!=null)
        {
          if(res.provinciaVendedor.length>2)
          {
            this.getMunicipioByNameVendedor(res.provinciaVendedor);
          }
          else
          {
            console.log("PROVINCIA Vendedor MAL GUARDADA");
            this.provinciasVendedor.map((p) => {
              if (p.idprov.includes(res.provinciaVendedor)) {
                this.datosCliente.controls.provinciaVendedor.setValue(p.nomprov);
                this.provinciaVendedor = p.nomprov;
                console.log('Provincia getMunicipio: ', this.provinciaVendedor);
              }
            });
            this.getMunicipioByNameVendedor(this.datosCliente.controls.provinciaVendedor.value);
          }
        }
        this.datosCliente.controls.poblacionVendedor.setValue(res.poblacionVendedor);
        this.poblacionVendedor=res.poblacionVendedor;
        this.datosCliente.controls.puebloVendedor.setValue(res.puebloVendedor);
        this.datosCliente.controls.cpVendedor.setValue(res.cpVendedor);
        this.datosCliente.controls.tipoViaVendedor.setValue(res.tipoViaVendedor);
        this.datosCliente.controls.direccionVendedor.setValue(res.direccionVendedor);
        this.datosCliente.controls.direccionnumeroVendedor.setValue(res.direccionnumeroVendedor);
        this.datosCliente.controls.direccionpisoVendedor.setValue(res.direccionpisoVendedor);
        this.datosCliente.controls.direccionpuertaVendedor.setValue(res.direccionpuertaVendedor);
        this.datosCliente.controls.direccionBloqueVendedor.setValue(res.direccionBloqueVendedor);
        this.datosCliente.controls.direccionEscaleraVendedor.setValue(res.direccionEscaleraVendedor);
  
        //this.datosAyuda.controls.autonomiaKm.setValue(res.autonomiaElectrico);
        //this.datosAyuda.controls.autonomiaKm.setValue(res.autonomiaElectrico);
        //this.datosAyuda.controls.autonomiaKm.setValue(res.autonomiaElectrico);
        //this.datosAyuda.controls.autonomiaKm.setValue(res.autonomiaElectrico);
  
        this.datosAyuda.controls.autonomiaKm.setValue(res.autonomiaElectrico);
        this.datosAyuda.controls.tipoAyuda.setValue(res.tipoAyuda);
        this.datosAyuda.controls.tipoSolicitante.setValue(res.tipoSolicitante);
        this.datosAyuda.controls.tipoAdquisicion.setValue(res.tipoAdquisicion);
        this.datosAyuda.controls.IBAN.setValue(res.iban);
        this.datosAyuda.controls.adicional.setValue(res.ayudaAdicional);
        console.log("marcaModeloElectrico:"+res.marcaModeloElectrico);
        console.log(res.marcaModeloElectrico);
        this.marcaModelo.setValue(res.marcaModeloElectrico);
        //this.datosAyuda.controls.marcaModelo.setValue("A");
        if(res.demo===true)
          this.datosAyuda.controls.demo.setValue("1");
        else
          this.datosAyuda.controls.demo.setValue("0");
  
        if(res.vehiculoNuevo===true)
          this.datosAyuda.controls.vehiculoNuevo.setValue("1");
        else
          this.datosAyuda.controls.vehiculoNuevo.setValue("0");
  
        this.datosAyuda.controls.minimis.setValue(res.importeMinimis);
        this.datosAyuda.controls.potenciaKwh.setValue(res.potenciaElectrico);
        //this.datosAyuda.controls.cif.setValue(res.cif);
        //this.datosAyuda.controls.IAE.setValue(res.IAE);
        if(res.achatarra===true)
        {
          this.datosAyuda.controls.achatarra.setValue("1");
          this.achatarra = true;
        }
        else
        {
          this.datosAyuda.controls.achatarra.setValue("0");
          this.achatarra = false;
          if(this.esReinicia)
          {
            this.datosAyuda.controls.achatarra.setValue("1");
            this.achatarra = true;
          }
        }
  
        this.datosAyuda.controls.fechaAchatarrado.setValue(res.fechaAchatarrado);
        this.datosAyuda.controls.fechaInicioProyecto.setValue(res.fechaInicioProyecto);
        this.datosAyuda.controls.fechaFinalProyecto.setValue(res.fechaFinalProyecto);
        this.datosAyuda.controls.matriculaAchatarrado.setValue(res.matriculaAchatarrado);
        this.datosAyuda.controls.marcaAchatarrado.setValue(res.marcaAchatarrado);
        this.datosAyuda.controls.modeloAchatarrado.setValue(res.modeloAchatarrado);
        this.datosAyuda.controls.expedienteConsorcio.setValue(res.expedienteConsorcio);
  
  
  
        this.datosAyuda.controls.reduccionEmisiones.setValue(res.reduccionEmisiones);
        this.datosAyuda.controls.ahorroEnergetico.setValue(res.ahorroEnergetico);
        this.datosAyuda.controls.tipoInstalacion.setValue(res.tipoInstalacion);
        this.datosAyuda.controls.numeroConectores.setValue(res.numeroConectores);
        this.datosAyuda.controls.tipoConector.setValue(res.tipoConector);
        this.datosAyuda.controls.marcaModeloCargador.setValue(res.marcaModeloCargador);
        this.datosAyuda.controls.inversionTotal.setValue(res.inversionTotal);
  
  
  
        //VEHICULO
        
          this.datosVehiculos.controls.matricula.setValue(res.matricula);
          this.datosVehiculos.controls.bastidor.setValue(res.bastidor);
          this.datosVehiculos.controls.baseImponible.setValue(res.baseImponible);
          this.datosVehiculos.controls.tipoVehiculo.setValue(res.tipoVehiculo);
          this.datosVehiculos.controls.marca.setValue(res.marca);
          this.datosVehiculos.controls.modelo.setValue(res.modelo);
          this.datosVehiculos.controls.cv.setValue(res.cv);
          this.datosVehiculos.controls.co2.setValue(res.co2);
          this.datosVehiculos.controls.fechaMatriculacion.setValue(res.fechaMatriculacion);
          this.datosVehiculos.controls.cilindrada.setValue(res.cilindrada);
          this.datosVehiculos.controls.potenciaFiscal.setValue(res.potenciaFiscal);
  
          this.setTipoAyuda();
          this.mostrarCampos();
  
      }, (error) => {
        this.show=false;
        console.log(error);
      });
    }
  
    decodeJWT(): void {
      this.tokenInfo = jwtDecode(this.token);
      console.log("TOKEN INFO:");
      console.log(this.tokenInfo);
  
      if(this.tokenInfo.moves==true)
      {
        console.log("ES MOVES");
        this.esMoves=true;
      }
      else
      {
        console.log("ES REINICIA");
        this.esReinicia=true;
      }
  
      this.idSolicitud=this.tokenInfo.id;
      console.log("IDSOLICITUD");
      console.log(this.idSolicitud);
    }
  
    clasificaciones(): void {
      this.clasif = [
        { id: '03', descripcion: '03xx – CICLOMOTOR' },
        { id: '04', descripcion: '04xx – MOTOCICLETA' },
        { id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS' },
        { id: '10', descripcion: '10xx – TURISMO' },
        { id: '17', descripcion: '17xx – PICK UP' },
        { id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg' },
        { id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg' },
        { id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg' },
        { id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg' },
        { id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE' },
        { id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg' },
        { id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg' },
        { id: '66', descripcion: '66xx – QUAD ATV' },
      ];
    }
  
  
  
    siguiente(): void {
      this.datosCliente.controls.fechaNacimiento.setValue(
        this.date.transform(
          this.datosCliente.value.fechaNacimiento,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.controls.fechaAchatarrado.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaAchatarrado,
          'yyyy-MM-dd'
        )
      );
      this.datosAyuda.value.marcaModelo=this.marcaModelo.value;
      
  
      console.log(this.datosVehiculos.value);
      
      console.log("Datos Ayuda:");
      console.log(this.datosAyuda);
      this.datoTramite = this.datosAyuda;
      this.datoTramite.tipo = 'AYUDA MOVES';
      if(this.esReinicia)
        this.datoTramite.tipo = 'AYUDA REINICIA';
      this.datoTramite.numPedido = "";
      this.datoTramite.tipoTramite = "AYUDA MOVES";
      if(this.esReinicia)
        this.datoTramite.tipoTramite = "AYUDA REINICIA";
      this.datoTramite.solicitud=this.idSolicitud;
      console.log("Datos Trámite:");
      console.log(this.datoTramite.value);
  
      //this.isEditable3 = true;
      console.log("marcaModelo this.marcaModelo: "+this.marcaModelo.value);
      console.log("marcaModelo datoTramite VALUE: "+this.datoTramite.value["marcaModelo"]);
      Object.keys(this.datoTramite.value).forEach((key) => {
        
        if (
          this.datoTramite.value[key] !== null &&
          this.datoTramite.value[key] !== undefined
        ) {
          console.log("APPEND KEY: "+key);
          console.log("APPEND VALUE: "+this.datoTramite.value[key]);
          this.formData.append(key, this.datoTramite.value[key]);
        }
      });
      this.datoTramite = this.datosVehiculos;
      Object.keys(this.datoTramite.value).forEach((key) => {
        
        if (
          this.datoTramite.value[key] !== null &&
          this.datoTramite.value[key] !== undefined
        ) {
          console.log("APPEND KEY: "+key);
          console.log("APPEND VALUE: "+this.datoTramite.value[key]);
          this.formData.append(key, this.datoTramite.value[key]);
        }
      });
      this.formData.append("numPedido", this.idSolicitud);
      this.servicio.update_solicitud(this.formData).subscribe(
        (res) => {
          this.spinnerFirma = false;
          console.log(res);
          Swal.fire('', 'Los datos se han guardado', 'success');
          //this.router.navigateByUrl('/upload?token='+this.token);
          //this.router.navigate(['page/solicitudes']);
          //this.showUploaded=true;
          //this.show=false;
        },
        (error) => {
          this.spinnerFirma = false;
          console.log(error);
          if (error.status === 202) {
            Swal.fire(
              '',
              'La solicitud se ha guardado, pero hubo un error al subir los archivos! ',
              'warning'
            );
            
            this.showUploaded=true;
            this.show=false;
          } else if (error.status === 412) {
            Swal.fire('', error.error, 'warning');
            this.router.navigate(['page/solicitudes']);
          } else {
            Swal.fire('', error.error.message, 'warning');
          }
        }
      );
    }
  
    guardarDocumentos(): void {
      this.guardar();
      this.router.navigateByUrl('/upload?token='+this.token);
    }
  
    setTipoAyuda()
    {
      console.log("Tipo de ayuda:"+this.datosAyuda.controls.tipoAyuda.value);
      if(this.datosAyuda.controls.tipoAyuda.value=="PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO" || this.datosAyuda.controls.tipoAyuda.value=="VEHICULO")
      {
        this.tipoAyudaSigla="V";
      }
      else
      {
        this.tipoAyudaSigla="P";
      }
      console.log("Tipo de ayuda sigla:"+this.tipoAyudaSigla);
    }
  
    completar()
    {
      this.completada=!this.completada;    
    }
    completar2()
    {
      this.completada2=!this.completada2;
    }
  
    completar3()
    {
      this.completada3=!this.completada3;
    }
  
    cerrar(): void{
      this.dialogRef.close();
    }

    guardar(): void {
      console.log("GUARDANDO");
      this.datosCliente.controls.fechaNacimiento.setValue(
        this.date.transform(
          this.datosCliente.value.fechaNacimiento,
          'yyyy-MM-dd'
        )
      );

      this.datosCliente.controls.fechaNacimientoVendedor.setValue(
        this.date.transform(
          this.datosCliente.value.fechaNacimientoVendedor,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.controls.fechaInicioProyecto.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaInicioProyecto,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.controls.fechaFinalProyecto.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaFinalProyecto,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.controls.fechaAchatarrado.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaAchatarrado,
          'yyyy-MM-dd'
        )
      );
  
      this.datosVehiculos.controls.fechaMatriculacion.setValue(
        this.date.transform(
          this.datosVehiculos.value.fechaMatriculacion,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.value.marcaModelo=this.marcaModelo.value;
      
  
      console.log(this.datosVehiculos.value);
      
      console.log("Datos Ayuda:");
      console.log(this.datosAyuda);
      this.datoTramite = this.datosAyuda;
      this.datoTramite.value.tipo = 'AYUDA MOVES';
      if(this.esReinicia)
        this.datoTramite.value.tipo = 'AYUDA REINICIA';
      this.datoTramite.value.numPedido = "";
      this.datoTramite.value.tipoTramite = "AYUDA MOVES";
      if(this.esReinicia)
        this.datoTramite.value.tipoTramite = 'AYUDA REINICIA';
      this.datoTramite.value.solicitud=this.idSolicitud;
      //this.datoTramite.value.completada=this.completada;
      //console.log("Datos Trámite:");
      //console.log(this.datoTramite.value);
  
      //this.isEditable3 = true;
      console.log("marcaModelo this.marcaModelo: "+this.marcaModelo.value);
      console.log("marcaModelo datoTramite VALUE: "+this.datoTramite.value["marcaModelo"]);
      Object.keys(this.datoTramite.value).forEach((key) => {
        
        if (
          this.datoTramite.value[key] !== null &&
          this.datoTramite.value[key] !== undefined
        ) {
          console.log("APPEND KEY: "+key);
          console.log("APPEND VALUE: "+this.datoTramite.value[key]);
          this.formData.append(key, this.datoTramite.value[key]);
        }
      });
      //this.datoTramite = this.datosVehiculos;
      Object.keys(this.datosVehiculos.value).forEach((key) => {
        
        if (
          this.datosVehiculos.value[key] !== null &&
          this.datosVehiculos.value[key] !== undefined
        ) {
          console.log("APPEND KEY: "+key);
          console.log("APPEND VALUE: "+this.datosVehiculos.value[key]);
          this.formData.append(key, this.datosVehiculos.value[key]);
        }
      });
      //this.datoTramite = this.datosCliente;
      //console.log("Datos vehículo:");
      //console.log(this.datosVehiculos.value);
  
      //this.isEditable3 = true;
      Object.keys(this.datosCliente.value).forEach((key) => {
        
        if (
          this.datosCliente.value[key] !== null &&
          this.datosCliente.value[key] !== undefined
        ) {
          console.log("APPEND KEY: "+key);
          console.log("APPEND VALUE: "+this.datosCliente.value[key]);
          if(key=="provincia")
          {
            this.datosCliente.value.provincia=this.provincia;
            console.log("APPEND KEY PROVINCIA: "+key);
            console.log("APPEND VALUE PROVINCIA: "+this.datosCliente.value[key]);
          }
          if(key=="provinciaVendedor")
          {
            this.datosCliente.value.provinciaVendedor=this.provinciaVendedor;
            console.log("APPEND KEY PROVINCIA VENDEDOR: "+key);
            console.log("APPEND VALUE PROVINCIA VENDEDOR: "+this.datosCliente.value[key]);
          }
          this.formData.append(key, this.datosCliente.value[key]);
          
        }
      });
      this.formData.append("numPedido", this.idSolicitud);
  
      this.servicio.update_solicitud(this.formData).subscribe(
        (res) => {
          this.spinnerFirma = false;
          console.log(res);
          Swal.fire('', 'Los datos se han guardado', 'success');
          this.showUploaded=true;
          this.router.navigate(['page/solicitudes']);
          this.dialogRef.close();
          
          //this.show=false;
        },
        (error) => {
          this.spinnerFirma = false;
          console.log(error);
          if (error.status === 202) {
            Swal.fire(
              '',
              'La solicitud se ha guardado, pero hubo un error al subir los archivos! ',
              'warning'
            );
            
            this.showUploaded=true;
            this.show=false;
          } else if (error.status === 412) {
            Swal.fire('', error.error, 'warning');
            //this.router.navigate(['page/solicitudes']);
          } else {
            Swal.fire('', error.error.message, 'warning');
          }
        }
      );
    }
  
    finalizar(): void {
      //this.comprobarCamposRequeridos();
      if(this.requeridosOK)
      {
        console.log("Finalizando");
        this.formData.append("finalizar", "0");
        //this.btnFinalizar=false;
        this.spinnerFirma = true;
        console.log("Finalizar:"+this.btnFinalizar);
        this.guardar();
      }
    }
    comprobarCamposRequeridos(): void{
      var formOK=true;
      this.faltaMarcaModelo=false;
      console.log("-------INICIO datosVehiculos");
      Object.keys(this.datosVehiculos.value).forEach((key) => {
        const control = this.datosVehiculos.get(key);
        console.log('Key = ' + key + ' Value = ' +   this.datosVehiculos.controls[key].value);
        if(!this.esReinicia){
          if(key=="baseImponible" && (control.value=="" || control.value==undefined))
            {
              this.datosVehiculos.get('baseImponible').setValidators([Validators.required]);
              this.datosVehiculos.get('baseImponible').updateValueAndValidity();
              this.datosVehiculos.controls[key].setErrors({'incorrect': true});
              this.datosVehiculos.controls[key].markAsTouched();
              formOK=false;
            }
        }
      });
      console.log("-------FIN datosVehiculos");
      Object.keys(this.datosCliente.controls).forEach(key =>{
        const control = this.datosCliente.get(key);
        //this.datosCliente.controls[key].markAsUntouched();
        console.log('Key = ' + key + ' Value = ' +   this.datosCliente.controls[key].value);
          if(key=="nif" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="apellido1" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="apellido2" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="nombre" && (control.value=="" || control.value==undefined))
          {
  
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="telefono" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="fechaNacimiento" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="sexo" && (control.value=="" || control.value==undefined))
          {
            this.datosCliente.controls[key].setErrors({'incorrect': true});
            this.datosCliente.controls[key].markAsTouched();
            formOK=false;
          }
          if(key=="sexo" && control.value=="EMPRESA")
          {
            if(this.datosCliente.controls.nifApoderado.value=="" || this.datosCliente.controls.nifApoderado.value==undefined)
            {
              this.datosCliente.controls.nifApoderado.setErrors({'incorrect': true});
              this.datosCliente.controls.nifApoderado.markAsTouched();
              formOK=false;
            }
            if(this.datosCliente.controls.nombreApoderado.value=="" || this.datosCliente.controls.nombreApoderado.value==undefined)
            {
              this.datosCliente.controls.nombreApoderado.setErrors({'incorrect': true});
              this.datosCliente.controls.nombreApoderado.markAsTouched();
              formOK=false;
            }
            if(this.datosCliente.controls.apellido1Apoderado.value=="" || this.datosCliente.controls.apellido1Apoderado.value==undefined)
            {
              this.datosCliente.controls.apellido1Apoderado.setErrors({'incorrect': true});
              this.datosCliente.controls.apellido1Apoderado.markAsTouched();
              formOK=false;
            }
            if(this.datosCliente.controls.apellido2Apoderado.value=="" || this.datosCliente.controls.apellido2Apoderado.value==undefined)
            {
              this.datosCliente.controls.apellido2Apoderado.setErrors({'incorrect': true});
              this.datosCliente.controls.apellido2Apoderado.markAsTouched();
              formOK=false;
            }
            if(this.datosCliente.controls.conceptoRepresentacionApoderado.value=="" || this.datosCliente.controls.conceptoRepresentacionApoderado.value==undefined)
            {
              this.datosCliente.controls.conceptoRepresentacionApoderado.setErrors({'incorrect': true});
              this.datosCliente.controls.conceptoRepresentacionApoderado.markAsTouched();
              formOK=false;
            }
          } 
          
  
          if(key=="provincia" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="poblacion" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="cp" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="tipoVia" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="direccion" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="direccionnumero" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            //ToDo: al seleccionar provincia se asigna el primer municipio como valor y el campo nunca aparece vacío 
        });
  
      if(this.esReinicia)
      {/*
        Object.keys(this.datosCliente.controls).forEach(key =>{
          const control = this.datosCliente.get(key);
          //this.datosCliente.controls[key].markAsUntouched();
          console.log('Key = ' + key + ' Value = ' +   this.datosCliente.controls[key].value);
            if(key=="nif" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="telefono" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="nombre" && (control.value=="" || control.value==undefined))
            {
  
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="apellido1" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="provincia" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="poblacion" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="cp" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="tipoVia" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="direccion" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="direccionnumero" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="sexo" && (control.value=="" || control.value==undefined))
            {
              this.datosCliente.controls[key].setErrors({'incorrect': true});
              this.datosCliente.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="sexo" && control.value=="EMPRESA")
            {
              if(this.datosCliente.controls.nifApoderado.value=="" || this.datosCliente.controls.nifApoderado.value==undefined)
              {
                this.datosCliente.controls.nifApoderado.setErrors({'incorrect': true});
                this.datosCliente.controls.nifApoderado.markAsTouched();
                formOK=false;
              }
              if(this.datosCliente.controls.nombreApoderado.value=="" || this.datosCliente.controls.nombreApoderado.value==undefined)
              {
                this.datosCliente.controls.nombreApoderado.setErrors({'incorrect': true});
                this.datosCliente.controls.nombreApoderado.markAsTouched();
                formOK=false;
              }
              if(this.datosCliente.controls.apellido1Apoderado.value=="" || this.datosCliente.controls.apellido1Apoderado.value==undefined)
              {
                this.datosCliente.controls.apellido1Apoderado.setErrors({'incorrect': true});
                this.datosCliente.controls.apellido1Apoderado.markAsTouched();
                formOK=false;
              }
              if(this.datosCliente.controls.apellido2Apoderado.value=="" || this.datosCliente.controls.apellido2Apoderado.value==undefined)
              {
                this.datosCliente.controls.apellido2Apoderado.setErrors({'incorrect': true});
                this.datosCliente.controls.apellido2Apoderado.markAsTouched();
                formOK=false;
              }
              if(this.datosCliente.controls.conceptoRepresentacionApoderado.value=="" || this.datosCliente.controls.conceptoRepresentacionApoderado.value==undefined)
              {
                this.datosCliente.controls.conceptoRepresentacionApoderado.setErrors({'incorrect': true});
                this.datosCliente.controls.conceptoRepresentacionApoderado.markAsTouched();
                formOK=false;
              }
            } 
        });*/
        Object.keys(this.datosAyuda.controls).forEach(key =>{
          const control = this.datosAyuda.get(key);
          //this.datosAyuda.controls[key].markAsUntouched();
          console.log('Key = ' + key + ' Value = ' +   this.datosAyuda.controls[key].value);
          /*
            if(key=="vehiculoNuevo" && control.value==0)
            {
              control.setErrors({'incorrect': true});
              control.markAsTouched();
              formOK=false;
          }*/
            if(key=="expedienteConsorcio" && (control.value==undefined || control.value==""))
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="tipoSolicitante" && control.value==0)
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="achatarra" && control.value=="1")
            {
              /*if(this.datosAyuda.controls.fechaAchatarrado.value==null)
              {
                this.datosAyuda.controls.fechaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.fechaAchatarrado.markAsTouched();
                formOK=false;
              }*/
              if(this.datosAyuda.controls.matriculaAchatarrado.value=="" || this.datosAyuda.controls.matriculaAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.matriculaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.matriculaAchatarrado.markAsTouched();
                formOK=false;
              }
              if(this.datosAyuda.controls.marcaAchatarrado.value=="" || this.datosAyuda.controls.marcaAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.marcaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.marcaAchatarrado.markAsTouched();
                formOK=false;
              }
              if(this.datosAyuda.controls.modeloAchatarrado.value=="" || this.datosAyuda.controls.modeloAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.modeloAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.modeloAchatarrado.markAsTouched();
                formOK=false;
              }
            }         
        });
      }
      else
      {
        Object.keys(this.datosAyuda.controls).forEach(key =>{
          const control = this.datosAyuda.get(key);
          //this.datosAyuda.controls[key].markAsUntouched();
          console.log('Key = ' + key + ' Value = ' +   this.datosAyuda.controls[key].value);
          /*
            if(key=="vehiculoNuevo" && control.value==0)
            {
              control.setErrors({'incorrect': true});
              control.markAsTouched();
              formOK=false;
          }*/
            if(key=="tipoAyuda" && (control.value==undefined || control.value==""))
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="tipoSolicitante" && control.value==0)
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="tipoAdquisicion" && (control.value==undefined || control.value==""))
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="IBAN" && (control.value==undefined || control.value==""))
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(key=="potenciaKwh" && (control.value==undefined || control.value==""))
            {
              this.datosAyuda.controls[key].setErrors({'incorrect': true});
              this.datosAyuda.controls[key].markAsTouched();
              formOK=false;
            }
            if(this.tipoAyudaSigla=="V")
            {
              
              if(key=="autonomiaKm" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              
              if(key=="marcaModelo" && (this.marcaModelo.value==undefined || this.marcaModelo.value==""))
              {
                console.log("DENTRO MarcaModelo");
                //console.log(this.datosAyuda.value.marcaModelo);
                console.log(this.marcaModelo.value);
                //this.datosAyuda.value.marcaModelo=this.marcaModelo.value;
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                this.faltaMarcaModelo=true;
                console.log("VALOR faltaMarcaModelo:"+this.faltaMarcaModelo);
                formOK=false;
              }
            }
            if(this.tipoAyudaSigla=="P")
            {
              if(key=="fechaInicioProyecto" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="fechaFinalProyecto" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="reduccionEmisiones" && control.value==0)
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="ahorroEnergetico" && control.value==0)
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="tipoInstalacion" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="numeroConectores" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                this.datosAyuda.controls[key].markAsDirty();
                formOK=false;
              }
              if(key=="tipoConector" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="inversionTotal" && control.value==0)
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="marcaModeloCargador" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
            }
            if(key=="achatarra" && control.value=="1")
            {
              /*if(this.datosAyuda.controls.fechaAchatarrado.value==null)
              {
                this.datosAyuda.controls.fechaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.fechaAchatarrado.markAsTouched();
                formOK=false;
              }*/
              if(this.datosAyuda.controls.matriculaAchatarrado.value=="" || this.datosAyuda.controls.matriculaAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.matriculaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.matriculaAchatarrado.markAsTouched();
                formOK=false;
              }
              if(this.datosAyuda.controls.marcaAchatarrado.value=="" || this.datosAyuda.controls.marcaAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.marcaAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.marcaAchatarrado.markAsTouched();
                formOK=false;
              }
              if(this.datosAyuda.controls.modeloAchatarrado.value=="" || this.datosAyuda.controls.modeloAchatarrado.value==undefined)
              {
                this.datosAyuda.controls.modeloAchatarrado.setErrors({'incorrect': true});
                this.datosAyuda.controls.modeloAchatarrado.markAsTouched();
                formOK=false;
              }
            }         
        });
      }
      this.requeridosOK=formOK;
    }
  
    comprobarDato(control: FormControl): any {
      const DNI_REGEX = /^(\d{8})([A-Z])$/;
      const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
      const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
      const str = control.value;
      /*console.log(str);
      console.log(DNI_REGEX.test(str));
      console.log(CIF_REGEX.test(str));
      console.log(NIE_REGEX.test(str));*/
      if (DNI_REGEX.test(str) || CIF_REGEX.test(str) || NIE_REGEX.test(str)) {
        return null;
      } else {
        return { error: { str: true } };
      }
    }
  
    getMunicipioByName(provincia: any): any {
      console.log('Provincia getMunicipioByName 1: ', provincia);
      console.log('Provincias getMunicipioByName: ', this.provincias);
   
      this.provincias.map((p) => {
        if (p.nomprov.includes(provincia)) {
          this.provinciaId = p.idprov;
          this.provincia = p.nomprov;
          console.log('Provincia getMunicipioByName 2: ', this.provinciaId);
        }
      });
      this.servicio
        .getMuninicipio(this.provinciaId)
        .subscribe(
          async (res) => {
            this.municipios = await res;
          },
          (error) => {
            console.log(error);
          }
        );
      
      console.log(this.datosCliente);
    }

    getMunicipioByNameVendedor(provincia: any): any {
      console.log('Provincia getMunicipioByNameVendedor 1: ', this.provinciaVendedor);
      console.log('Provincias getMunicipioByNameVendedor: ', this.provinciasVendedor);
   
      this.provinciasVendedor.map((p) => {
        if (p.nomprov.includes(this.provinciaVendedor)) {
          this.provinciaIdVendedor = p.idprov;
          this.provinciaVendedor = p.nomprov;
          console.log('Provincia getMunicipioByName 2: ', this.provinciaIdVendedor);
        }
      });
      this.servicio
        .getMuninicipio(this.provinciaIdVendedor)
        .subscribe(
          async (res) => {
            this.municipiosVendedor = await res;
          },
          (error) => {
            console.log(error);
          }
        );
      
      console.log(this.datosCliente);
    }
  
    getMunicipio(): any {
      
      if (this.datosCliente.value.provincia) {
        this.provincias.map((p) => {
          if (p.idprov.includes(this.datosCliente.value.provincia)) {
            this.provincia = p.nomprov;
            console.log('Provincia getMunicipio: ', this.provincia);
          }
        });
        this.servicio
          .getMuninicipio(this.datosCliente.value.provincia)
          .subscribe(
            async (res) => {
              this.municipios = await res;
            },
            (error) => {
              console.log(error);
            }
          );
      }
      console.log(this.datosCliente);
    }

    getMunicipioVendedor(): any {
      
      if (this.datosCliente.value.provinciaVendedor) {
        this.provincias.map((p) => {
          if (p.idprov.includes(this.datosCliente.value.provinciaVendedor)) {
            this.provinciaVendedor = p.nomprov;
            console.log('Provincia Vendedor getMunicipio: ', this.provinciaVendedor);
          }
        });
        this.servicio
          .getMuninicipio(this.datosCliente.value.provinciaVendedor)
          .subscribe(
            async (res) => {
              this.municipiosVendedor = await res;
            },
            (error) => {
              console.log(error);
            }
          );
      }
      console.log(this.datosCliente);
    }
  
    comprobarNumero(control: FormControl) {
      const numero = /^[0-9]{9}$/;
      const str = control.value;
      /*console.log(str);
      console.log(numero.test(str));*/
      if (numero.test(str)) {
        return null;
      } else {
        return { error: { str: true } };
      }
    }
  
    getSiglas(): any {
      this.servicio.getSiglas().subscribe(
        async (res) => {
          console.log('Siglas', res);
          this.siglas = await res;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  
  /*
    siguiente2($event: any): void {
      this.DatosClienteVendedor = {
        nifVendedor: $event.nif,
        apellido1Vendedor: $event.apellido1,
        apellido2Vendedor: $event.apellido2,
        nombreVendedor: $event.nombre,
        nifApoderadoVendedor: $event.nifApoderado,
        apellido1ApoderadoVendedor: $event.apellido1Apoderado,
        apellido2ApoderadoVendedor: $event.apellido2Apoderado,
        nombreApoderadoVendedor: $event.nombreApoderado,
        conceptoRepresentacionApoderadoVendedor:
          $event.conceptoRepresentacionApoderado,
        fechaNacimientoVendedor: $event.fechaNacimiento,
        sexoVendedor: $event.sexo,
        emailVendedor: $event.email,
        telefonoVendedor: $event.telefono,
        enviarDocCorreoVendedor: $event.enviarDocCorreo,
        provinciaVendedor: $event.provincia,
        poblacionVendedor: $event.poblacion,
        puebloVendedor: $event.pueblo,
        cpVendedor: $event.cp,
        tipoViaVendedor: $event.tipoVia,
        direccionVendedor: $event.direccion,
        direccionnumeroVendedor: $event.direccionnumero,
        direccionpisoVendedor: $event.direccionpiso,
        direccionpuertaVendedor: $event.direccionpuerta,
      };
      console.log(this.DatosClienteVendedor);
      this.isEditable1 = true;
    }
  
    siguiente3($event: any): void {
      this.datoTramite = {
        ...$event,
        ...this.DatosClienteVendedor,
        ...this.datosVehiculos.value,
      };
      const c = this.clasif.find(
        (res) => res.id === this.datosVehiculos.value.tipoVehiculo
      );
      this.datoTramite.tipoVehiculo = c.descripcion;
      this.datoTramite.tipo = 'CAMBIO DE PROPIEDAD';
      this.datoTramite.numPedido = sessionStorage.getItem('numPedido');
      this.datoTramite.tipoTramite = sessionStorage.getItem('tipoTramite');
      this.datoTramite.justificante = sessionStorage.getItem('justificante');
      this.datoTramite.colaborador = sessionStorage.getItem('colaborador');
      this.datoTramite.usuarioweb = sessionStorage.getItem('email');
      console.log('DatoTramite completo', this.datoTramite);
      this.isEditable2 = true;
      this.isEditable3 = true;
    }
      */
  }
  